import { Info } from 'lucide-react';

interface InfoTooltipProps {
  text: string;
}

export default function InfoTooltip({ text }: InfoTooltipProps) {
  return (
    <div className="relative inline-flex group">
      <Info size={14} className="text-slate-400 hover:text-indigo-500 cursor-help transition-colors" />
      <div className="invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity absolute left-1/2 -translate-x-1/2 top-full mt-2 z-20 w-64 bg-slate-800 text-white text-xs leading-relaxed rounded-lg px-3 py-2 shadow-lg pointer-events-none">
        {text}
        <div className="absolute left-1/2 -translate-x-1/2 bottom-full w-2 h-2 bg-slate-800 rotate-45" />
      </div>
    </div>
  );
}
